import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandler } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Respuesta } from '../models';

@Injectable({
  providedIn: 'root'
})
export class GestionSgmmService {

  url = environment.api;
  constructor(private http: HttpClient, private errorHandler: ErrorHandler) {}


  obtenerListado(){
    return this.http.get(`${this.url}Colaborador/solicitud-reembolso`).pipe(
      map((response: Respuesta) => response),
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener el listado de SGMM'));
      })
    );
  }

    obtenerListadoColaborador(id: number){
    return this.http.get(`${this.url}Colaborador/${id}/solicitud-reembolso`).pipe(
      map((response: Respuesta) => response),
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener el listado de SGMM'));
      })
    );
  }

  descargarExcel( params: {}) {
    
    return this.http.get(`${this.url}Colaborador/solicitud-reembolso/excel`, { responseType: 'blob' })
  }

  obtenerDetalle(id: number){
    return this.http.get(`${this.url}Colaborador/solicitud-reembolso/${id}`).pipe(
      map((response: Respuesta) => response),
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener el detalle del usuario'));
      })
    );
  }

  descargarArchivo(id: number, name: string): Observable<Blob> {
    const params = new HttpParams().set('idFactura', id.toString()).set('nombreArchivo', name);
    return this.http.get(`${this.url}Colaborador/solicitud-reembolso/descargar-factura`, { responseType: 'blob', params });
  }

}
